export default __webpack_public_path__ + "static/media/crew-01.f0688cf4.svg";